const DESKTOP_ROW_CROSSHAIR_INDICES = [
  [0, 1, 5, 6],
  [1, 2, 6, 7],
  [2, 3, 7, 8],
  [3, 4, 8, 9],
];

const MOBILE_ROW_CROSSHAIR_INDICES = [
  [0, 1, 3, 4],
  [1, 2, 4, 5],
];

export class SocialPosts {
  desktopRowElements: HTMLDivElement[];
  mobileRowElements: HTMLDivElement[];

  desktopCrosshairSVGs: SVGSVGElement[];
  mobileCrosshairSVGs: SVGSVGElement[];

  prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)")
    .matches;

  constructor() {
    const socialSection = document.querySelector(
      "#social-section"
    ) as HTMLDivElement;
    this.desktopRowElements = Array.from(
      socialSection.querySelectorAll("[data-social-images-desktop-row]")
    ) as HTMLDivElement[];

    this.mobileRowElements = Array.from(
      socialSection.querySelectorAll("[data-social-images-mobile-row]")
    ) as HTMLDivElement[];

    this.desktopCrosshairSVGs = Array.from(
      socialSection.querySelectorAll(".homepage-section-border--desktop svg")
    ) as SVGSVGElement[];

    this.mobileCrosshairSVGs = Array.from(
      socialSection.querySelectorAll(".homepage-section-border--mobile svg")
    ) as SVGSVGElement[];

    if (!this.prefersReducedMotion) {
      this.init();
    }
  }

  init() {
    this.desktopRowElements.forEach((row, rowIndex) => {
      Array.from(row.children).forEach((cell, cellIndex) => {
        cell.addEventListener("mouseover", () =>
          this.onDesktopImageMouseOver(rowIndex, cellIndex)
        );

        cell.addEventListener("mouseout", this.onDesktopImageMouseOut);
      });
    });

    this.mobileRowElements.forEach((row, rowIndex) => {
      Array.from(row.children).forEach((cell, cellIndex) => {
        cell.addEventListener("mouseover", () =>
          this.onMobileImageMouseOver(rowIndex, cellIndex)
        );

        cell.addEventListener("mouseout", this.onMobileImageMouseOut);
      });
    });
  }

  onDesktopImageMouseOver = (rowIndex: number, cellIndex: number) => {
    const rowIndexOffset = rowIndex * 5;

    const topLeftIndex =
      DESKTOP_ROW_CROSSHAIR_INDICES[cellIndex][0] + rowIndexOffset;
    const topRightIndex =
      DESKTOP_ROW_CROSSHAIR_INDICES[cellIndex][1] + rowIndexOffset;
    const bottomLeftIndex =
      DESKTOP_ROW_CROSSHAIR_INDICES[cellIndex][2] + rowIndexOffset;
    const bottomRightIndex =
      DESKTOP_ROW_CROSSHAIR_INDICES[cellIndex][3] + rowIndexOffset;

    this.desktopCrosshairSVGs.forEach((svg, i) => {
      switch (i) {
        case topLeftIndex:
          svg.children[0].setAttribute(
            "style",
            "transform: translate(-5px, 0px)"
          );
          svg.children[1].setAttribute(
            "style",
            "transform: translate(0px, -5px)"
          );
          break;
        case topRightIndex:
          svg.children[0].setAttribute(
            "style",
            "transform: translate(5px, 0px)"
          );
          svg.children[1].setAttribute(
            "style",
            "transform: translate(0px, -5px)"
          );
          break;
        case bottomLeftIndex:
          svg.children[0].setAttribute(
            "style",
            "transform: translate(-5px, 0px)"
          );
          svg.children[1].setAttribute(
            "style",
            "transform: translate(0px, 5px)"
          );
          break;
        case bottomRightIndex:
          svg.children[0].setAttribute(
            "style",
            "transform: translate(5px, 0px)"
          );
          svg.children[1].setAttribute(
            "style",
            "transform: translate(0px, 5px)"
          );
          break;
        default:
          svg.children[0].setAttribute(
            "style",
            "transform: translate(0px, 0px)"
          );
          svg.children[1].setAttribute(
            "style",
            "transform: translate(0px, 0px)"
          );
          break;
      }
    });
  };

  onDesktopImageMouseOut = () => {
    this.desktopCrosshairSVGs.forEach((svg) => {
      svg.children[0].setAttribute("style", "transform: translate(0px, 0px)");
      svg.children[1].setAttribute("style", "transform: translate(0px, 0px)");
    });
  };

  onMobileImageMouseOver = (rowIndex: number, cellIndex: number) => {
    const rowIndexOffset = rowIndex * 3;

    const topLeftIndex =
      MOBILE_ROW_CROSSHAIR_INDICES[cellIndex][0] + rowIndexOffset;
    const topRightIndex =
      MOBILE_ROW_CROSSHAIR_INDICES[cellIndex][1] + rowIndexOffset;
    const bottomLeftIndex =
      MOBILE_ROW_CROSSHAIR_INDICES[cellIndex][2] + rowIndexOffset;
    const bottomRightIndex =
      MOBILE_ROW_CROSSHAIR_INDICES[cellIndex][3] + rowIndexOffset;

    this.mobileCrosshairSVGs.forEach((svg, i) => {
      switch (i) {
        case topLeftIndex:
          svg.children[0].setAttribute(
            "style",
            "transform: translate(-5px, 0px)"
          );
          svg.children[1].setAttribute(
            "style",
            "transform: translate(0px, -5px)"
          );
          break;
        case topRightIndex:
          svg.children[0].setAttribute(
            "style",
            "transform: translate(5px, 0px)"
          );
          svg.children[1].setAttribute(
            "style",
            "transform: translate(0px, -5px)"
          );
          break;
        case bottomLeftIndex:
          svg.children[0].setAttribute(
            "style",
            "transform: translate(-5px, 0px)"
          );
          svg.children[1].setAttribute(
            "style",
            "transform: translate(0px, 5px)"
          );
          break;
        case bottomRightIndex:
          svg.children[0].setAttribute(
            "style",
            "transform: translate(5px, 0px)"
          );
          svg.children[1].setAttribute(
            "style",
            "transform: translate(0px, 5px)"
          );
          break;
        default:
          svg.children[0].setAttribute(
            "style",
            "transform: translate(0px, 0px)"
          );
          svg.children[1].setAttribute(
            "style",
            "transform: translate(0px, 0px)"
          );
          break;
      }
    });
  };

  onMobileImageMouseOut = () => {
    this.mobileCrosshairSVGs.forEach((svg) => {
      svg.children[0].setAttribute("style", "transform: translate(0px, 0px)");
      svg.children[1].setAttribute("style", "transform: translate(0px, 0px)");
    });
  };
}
